module.exports = __webpack_public_path__ + "static/media/18c-06-HOME_ST-2018-200x300cm-oleo-sobre-madera.742be7d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/18c/18c-06-HOME_ST-2018-200x300cm-oleo-sobre-madera.jpg
// module id = 233
// module chunks = 0